import { forwardRef, useImperativeHandle, useRef } from 'react';
import ReactPhoneInput, { type Props as ReactPhoneInputProps } from 'react-phone-number-input/input';
import {Input, type InputProps, type InputRef} from 'antd';

export type InputPhoneProps = Omit<ReactPhoneInputProps<InputProps>, 'onChange'> & {
    onChange?: ReactPhoneInputProps<InputProps>['onChange'];
};

const WrappedInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
    const inputRef = useRef<InputRef>(null);

    useImperativeHandle(ref, () => inputRef.current?.input as HTMLInputElement, []);

    return <Input {...props} ref={inputRef} />;
});

export const InputPhone = forwardRef<HTMLInputElement, InputPhoneProps>(({ onChange, ...props }, ref) => (
    <ReactPhoneInput {...props} onChange={onChange || (() => {})} inputComponent={WrappedInput} ref={ref} />
));